import activityRouterPaths from './activityRouterPaths';

export default activityRouterPaths;
